import React, { Component } from "react";
import Input from "../../common/Input";
import { ToastContainer } from 'react-toastify';
import { toaster } from '../../../config';
import { getQualtrics, updateQualtrics } from "../../../services/formService";
import { logActivity } from '../../../services/utilService';

class WQualtrics extends Component {
  state = {
    Qualtrics_ID: 0,
    survey: {
      Survey_ID: "",
      Display_Name: "",
    },
    // Widget information in props.Widget
  };

  constructor(props) {
    super(props);
    this.handleSave = this.handleSave.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }

  async componentDidMount() {
    try {
      const { data } = await getQualtrics(this.props.Widget.Widget_ID);
      this.setState({ Qualtrics_ID: data[0].Qualtrics_ID });
      const survey = { ...this.state.survey };
      survey.Survey_ID = data[0].Survey_ID;
      survey.Display_Name = data[0].Display_Name;
      this.setState({ survey });
    } catch (e) {}
  }

  handleChange = ({ currentTarget: input }) => {
    const survey = { ...this.state.survey };
    survey[input.name] = input.value;
    this.setState({ survey });
  };

  async handleSave() {
    const { Display_Name, Survey_ID } = this.state.survey;

    if (Display_Name && Survey_ID) {
      const { data } = await updateQualtrics(
        this.state.Qualtrics_ID,
        this.props.Widget.Widget_ID,
        Survey_ID,
        Display_Name
      );
      if (data.includes("Success")) {
        const Qualtrics_ID = data.split(":").pop();
        this.setState({ Qualtrics_ID });
        toaster('success', 'Qualtrics info saved successfully');
        logActivity('/formBuilder','WIDGET_QUALTRICSINFO_SAVE_SUCCESS');
      } else {
        toaster('error', data);
        logActivity('/formBuilder','WIDGET_QUALTRICSINFO_SAVE_FAILED');
      }
    } else {
      toaster('error', 'Please enter Qualtrics information');
    }
  }

  handleRemove() {
    this.props.onRemove(this.props.Widget.Widget_ID);
  }

  render() {
    const { survey } = this.state;
    return (
      <React.Fragment>
        <Input
          name="Display_Name"
          value={survey.Display_Name}
          label="Survey Display Name"
          onChange={this.handleChange}
        ></Input>

        <Input
          name="Survey_ID"
          value={survey.Survey_ID}
          label="Qualtrics Survey ID"
          onChange={this.handleChange}
        ></Input>

        <div className="float-right">
          <button
            className="btn btn-outline-primary m-2"
            onClick={this.handleSave}
          >
            Save
          </button>
          <button
            className="btn btn-outline-danger"
            onClick={this.handleRemove}
          >
            Delete
          </button>
        </div>
        <ToastContainer/>
      </React.Fragment>
    );
  }
}

export default WQualtrics;
